import { Fund } from 'common/types/fund';
import { Option } from 'pages/FundInvestments';
import { getArrayValue, getObjectValue, getStringValue } from 'utilities';
import { GetFundNameParams } from './getFundOptions.types';

export const getFundName = (params: GetFundNameParams): string => {
  const { fundId, fundOptions } = params;

  const fund = fundOptions?.find(option => option.value === fundId);

  return getStringValue(fund?.label);
};

const getFundOptions = (funds?: Fund[] | null): Option[] =>
  getArrayValue(
    funds?.map(currentFund => {
      const { id, name } = getObjectValue(currentFund);

      return {
        label: name,
        value: id,
      } as Option;
    })
  );

export default getFundOptions;
